<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Banners | Editar" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-banner v-if="banner && !loader.loading" :banner="banner" @submit="submit" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import TPageTitle from '@/components/TPageTitle.vue'
import FormBanner from './form-banner.vue'
import { Banner } from '@/types/Banner'
import BannerService from '@/services/BannerService'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRoute } from 'vue-router'
import { useRouter } from 'vue-router'
import { onMounted } from 'vue'
import { AxiosError } from 'axios'

const loader = useLoader()
const snackbar = useSnackBar()
const route = useRoute()
const router = useRouter()

let banner: Banner = {} as Banner
const id: string = route.params.id as string

onMounted(() => {
  fetch()
})

async function fetch() {
  try {
    loader.increment()

    const response = (await (new BannerService()).show(id)).data

    banner = response
  } catch {
    snackbar.show('Não foi possível carregar os dados do banner', 'error')
  } finally {
    loader.decrement()
  }
}

async function submit(model: Banner, image?: File) {
  try {
    loader.increment()

    await (new BannerService()).update(id, model, image)

    snackbar.show('Banner atualizado com sucesso', 'success')

    router.push({ name: 'list-banners' })
  } catch (error) {
    if (error instanceof AxiosError) {
      snackbar.show(error.response?.data?.message, 'error')
    } else if (error instanceof Error) {
      snackbar.show(error.message, 'error')
    } else {
      snackbar.show('Não foi possível atualizar as informações do banner', 'error')
    }
  } finally {
    loader.decrement()
  }
}

</script>
